const restaurant = {
  restaurant: "식당", // translated 
  restaurants: "레스토랑", // translated 
  category: "범주", // translated 
  score: "점수", // translated 
  priceQuartile: "가격 사분위수", // translated 
  scoreLowestFirst: "점수 (낮은 점수부터)", // translated 
  scoreHighestFirst: "점수 (가장 높은 점수부터)", // translated 
  priceLowestFirst: "가격 (낮은 가격부터)", // translated 
  priceHighestFirst: "가격 (높은 순서대로)", // translated 
  allPrices: "모든 가격은", // translated 
  reserve: "예약하다", // translated 
  dining: "식사", // translated 
};


export default restaurant;
